import $ from 'jquery';
import Plyr from 'plyr';

function videoBlock() {
    $('.video-block .video').each(function () {
        const videoElement = $(this).get(0);
        let poster = $(this).data('poster');
        let player = new Plyr(videoElement, {
          controls: [
            'play-large', 
            'play',       
            'rewind',     
            'fast-forward', 
            'progress',  
            'current-time', 
            'duration',   
            'mute',       
            'volume',     
            'captions',   
            'settings',   
            'fullscreen'  ],
            autoplay: false,
            vimeo: { autoplay: false },
            youtube: { autoplay: false },
            fullscreen: { enabled: false }
        });

        if (poster) player.poster = poster;

        player.on('ready', () => {
            // Event handler for showing the video
            $('.button-video-button').on('click', function () {
                $(videoElement).show(); // Show the video element
                player.play();
            });

            // Event handler for closing the video
            $('.button-video-button-close').on('click', function () {
                player.pause();
                $(videoElement).hide(); // Hide the video element
            });

            // Event handler for clicking outside the modal
            $('.modal').on('click', function (event) {
                if (!$(event.target).closest('.modal-content').length) {
                    player.pause();
                    $(videoElement).hide(); // Hide the video element
                }
            });

            // Event handler for toggling play/pause on video click
            $('.video').on('click touchstart', function (event) {
                event.preventDefault();
                event.stopPropagation();
                if (player.paused) {
                    player.play();
                } else {
                    player.pause();
                }
            });
        });
    });
}

function videoOrganizations() {
    const plyrElement = document.querySelector('.plyr');

    if (plyrElement) {
        const visibleObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                const isPaused = $(plyrElement).hasClass('plyr--paused');
                $(plyrElement).find('.video').toggleClass('paused', isPaused);
                $(plyrElement).find('.custom-play').toggleClass('hide', !isPaused);
            });
        });

        const observerConfig = { attributes: true, childList: true, subtree: true };
        visibleObserver.observe(plyrElement, observerConfig);
    }
}

export { videoBlock, videoOrganizations };
